var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-image"},[_c('img',{attrs:{"src":"/resources/images/empty/no-image.svg","alt":"No image"}}),_c('span',[_vm._v("No Image")])])
}]

export { render, staticRenderFns }